import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "../../../../../style";
import { styleSizes } from "constants/styleSizes";
import { bookingChangesStyles } from "../../styles";

export const AccountContentContainer = styled(BasicSectionContainer)`
  ${bookingChangesStyles}

  .cardContent {
    .datesText {
      font-size: 16px;
      font-weight: 400;
      color: ${colors.almostBlack};
      line-height: 24px;
    }
    .datesAvailabilityError {
      color: ${colors.red};
      padding-top: 20px;
    }
    .bookingDates {
      display: flex;
      margin-top: 32px;

      .checkInOut {
        position: relative;
        width: 342px;
        max-width: 100%;
        flex: none;

        .calendarIcon {
          position: absolute;
          top: 39px;
          right: 10px;
          cursor: pointer;
        }

        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          width: 100%;
        }
      }
    }
    .buttonContainer {
      margin-top: 32px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: row;
      align-content: center;
      gap: 24px;
      .cancelBt {
        font-size: 16px;
        font-weight: 700;
        color: ${colors.hoverBlue};
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
`;
